import React, { useState, useEffect } from "react";
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Registrando os componentes do Chart.js que iremos usar
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TicketsComponent = ({ data }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="stats-tooltip">
          <p className="label">Bilhete: {label}</p>
          <p className="label">Nº Bilhetes vendidos: {payload[0].value}</p>
        </div>
      );
    }
    return null;
  };





  /* Line chart NEW */

  const labelsTickets = data.graphTickets.map(register => register.date);
  const dataTickets = data.graphTickets.map(register => parseInt(register.numberTickets, 10));

  const chartDataTickets = {
    labels: labelsTickets, // Datas
    datasets: [
      {
        label: 'Número bilhetes vendidos',
        data: dataTickets, // Quantidade de registros
        borderColor: 'rgba(75, 192, 192, 1)', // Cor da linha
        backgroundColor: 'rgba(75, 192, 192, 0.2)', // Cor de fundo abaixo da linha
        fill: true, // Preencher a área abaixo da linha
        tension: 0.2, // Deixar a linha suave
      }
    ]
  };

  const optionsTickets = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: "white",
        }
      },
      title: {
        display: true,
        text: 'Vendas de Bilhetes'
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Data'
        },
        ticks: {
          color: "white",
        }
      },
      y: {
        title: {

          display: true,
          text: 'Vendas de Bilhetes'
        },
        beginAtZero: true,
        ticks: {
          color: "white",
          // Aqui garantimos que os valores mostrados no eixo Y sejam números inteiros
          callback: function (value) {
            if (Number.isInteger(value)) {
              return value;
            }
          },
          stepSize: 1, // Define o intervalo entre os números no eixo Y
        },
      }
    }
  };

  return data ? (
    <div>
      Venda de Bilhetes
      {/* <ResponsiveContainer width="100%" height={350}> */}
      {/* <BarChart data={data.graphTickets}>
          <Bar dataKey="numberTickets" fill="#366dc7" />
          <YAxis
            allowDecimals={false}
            tick={{ stroke: "white", strokeWidth: 0.5 }}
            label={{ angle: -90, position: "insideLeft" }}
          />
          <XAxis
            dataKey="date"
            tickMargin="10"
            tick={{ stroke: "white", strokeWidth: 0.5 }}
          />
          <Tooltip content={<CustomTooltip />} cursor={false} />
        </BarChart> 
        </ResponsiveContainer>*/}
      <div style={{ minWidth: '250px', minHeight: '250px', width: '100%', height: '100%' }}>
        <Line data={chartDataTickets} options={optionsTickets} />
      </div>

    </div>
  ) : null;
};

export default TicketsComponent;
